module.exports = __webpack_public_path__ + "img/Nothumbnail.54875dd2.png";